module.exports = __webpack_public_path__ + "img/News_Center_md.755865c3.png";